<template>
  <div class="severity-boxes">
    <v-card :loading="loading">
      <v-card-text>
        <div class="header">
          <span class="title">{{ items?.total_activity_tickets || 0 }}</span>
          <span class="icon-box">
            <v-icon>mdi-information</v-icon>
          </span>
        </div>
        <div class="mt-3 content">
          <div>Total Activity Tickets</div>
          <div class="sub-text">
            +12% vs last hour
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card
      :loading="loading"
      class="card-red"
    >
      <v-card-text>
        <div class="header">
          <span class="title">{{ items?.breached_sla || 0 }}</span>
          <span class="icon-box">
            <v-icon>mdi-alert-octagram</v-icon>
          </span>
        </div>
        <div class="mt-3 content">
          <div>Breached SLA</div>
          <div class="sub-text">
            Critical Action Required
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card
      :loading="loading"
      class="card-yellow"
    >
      <v-card-text>
        <div class="header">
          <span class="title">{{ items?.at_risk || 0 }}</span>
          <span class="icon-box">
            <v-icon>mdi-alert</v-icon>
          </span>
        </div>
        <div class="mt-3 content">
          <div>At Risk</div>
          <div class="sub-text">
            Immediate Attention advised
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-card :loading="loading">
      <v-card-text>
        <div class="severity-distribution">
          <span class="title">Severity Distribution</span>
          <v-icon>mdi-poll</v-icon>
        </div>
        <div class="mt-3 content">
          <div
            v-for="(r, i) in items?.severity_distribution"
            :key="i"
            class="mb-3"
          >
            <div class="d-flex justify-space-between align-center mb-1">
              <span>{{ r.code }} ({{ r.severity_level }})</span>
              <span><strong>{{ r.percentage }}%</strong></span>
            </div>
            <v-progress-linear
              :value="r.percentage"
              :color="getColor(r)"
              height="5"
            />
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      loading: "ticketManagement/getLoading",
      items: "ticketManagement/getSlaStatics",
    }),
  },
  methods: {
    getColor(r) {
      const code = r.severity_level;
      if (["high", "High"].includes(code)) {
        return "red";
      } else if (["medium", "Medium"].includes(code)) {
        return "light-green";
      } else if (["low", "Low"].includes(code)) {
        return "amber";
      } else {
        return "gray";
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.severity-boxes
  display: flex
  justify-content: space-between
  flex-wrap: wrap
  gap: 1rem


.severity-boxes .v-card
  flex: 1 1 calc(25% - 16px) /* Adjust the width and spacing as needed */
  // padding: 1rem /* Add some spacing between the cards */

.header
  display: flex
  justify-content: space-between
  align-items: center
  .title
    font-size: 2rem !important
    font-weight: 600
  .icon-box
    background-color: gray

.content
    color: gray
    div:last-child
        font-size: 0.875rem

.severity-distribution
    display: flex
    justify-content: space-between
    align-items: center
    .title
        font-size: 1.25rem !important
        font-weight: 600


.card-red
    border-radius: 10px
    border-left: 0.5rem solid red !important
    .header
        color: red !important
        .icon-box
            background-color: #f9cccc !important
            i
                color: red !important
    .content
        .sub-text
            color: red !important

.card-yellow
    border-radius: 10px
    border-left: 0.5rem solid #f0a100 !important
    .header
        color: #f0a100 !important
        .icon-box
            background-color: #ffe7b5 !important
            i
                color: #f0a100 !important
    .content
        .sub-text
            color: #f0a100 !important


@media only screen and (max-width: 960px)
    .severity-boxes
        flex-direction: column
</style>
